import { trace } from 'owa-trace';
import type { UserCustomProperties } from '../schema/UserCustomProperties';

let userCustomProperties: UserCustomProperties = null;
let resolveUserCustomPropertiesPromise;
const cb = resolve => {
    resolveUserCustomPropertiesPromise = resolve;
};
const isUserCustomPropertiesInitializedPromise = new Promise<boolean>(cb);

export const getIsUserCustomPropertiesInitializedPromise = (): Promise<boolean> =>
    isUserCustomPropertiesInitializedPromise;

export const getUserCustomProperties = (): UserCustomProperties => {
    if (!userCustomProperties) {
        trace.warn('UserCustomProperties is not initialized');
        return null;
    }

    return userCustomProperties;
};

export const initializeUserCustomProperties = (lookup: UserCustomProperties) => {
    if (userCustomProperties) {
        trace.warn('UserCustomProperties already initialized');
        return;
    }
    userCustomProperties = lookup;
    resolveUserCustomPropertiesPromise();
};

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export const setUserCustomProperties = (key: string, value: any) => {
    if (!userCustomProperties) {
        trace.warn('UserCustomProperties is not initialized');
    }

    userCustomProperties[key] = value;
};
